var map = {
	"./tutorial-normal-attraction-1.jpg": "27GY",
	"./tutorial-tool-attraction-1.jpg": "R/qx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "SZ5X";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/tutorial\-.*\-attraction\-1\.jpg$
// module id = SZ5X
// module chunks = 3